export const selectSecurityQuestionnaire = ({
  headquarters_country,
  data_processing_locations,
  security_standards,
  ...rest
} = {}) => rest;
